// Defined in general.js
/* global eraseCookie readCookie */

// Defined in JSP
/* global challengeId */

export function showLongMessage(longMessage) {
    if (longMessage) {
        document.getElementById('challengeMessageShort').style.display = 'none';
        document.getElementById('challengeMessageLong').style.display = 'block';
    } else {
        document.getElementById('challengeMessageShort').style.display = 'block';
        document.getElementById('challengeMessageLong').style.display = 'none';
    }
}

export function editToggle(elName, toggleState) {
    document.getElementById('challengeNameDisplay').style.display = 'block';
    document.getElementById('challengeNameForm').style.display = 'none';
    document.getElementById('sponsorMessageDisplay').style.display = 'block';
    document.getElementById('sponsorMessageForm').style.display = 'none';
    if (toggleState) {
        document.getElementById(elName + 'Display').style.display = 'none';
        document.getElementById(elName + 'Form').style.display = 'block';
    } else {
        document.getElementById(elName + 'Display').style.display = 'block';
        document.getElementById(elName + 'Form').style.display = 'none';
    }
}

export function validateChallengeForm(frm) {
    if (frm.challengeName != null && frm.challengeName.value === '') {
        alert('Please include a name for your Giving Page.');
        frm.challengeName.focus();
        return false;
    }
    if (frm.challengeName != null && frm.challengeName.value.length > 250) {
        alert('Your Giving Page name is too long. Please make it no more than 250 characters.');
        frm.challengeName.focus();
        return false;
    }
    if (frm.sponsorMessage != null && frm.sponsorMessage.value === '') {
        alert('Please include a description for your Giving Page.');
        frm.sponsorMessage.focus();
        return false;
    }
    if (frm.sponsorMessage != null && frm.sponsorMessage.value.length > 1500) {
        alert('Your Giving Page description is too long. Please make it no more than 1500 characters.');
        frm.sponsorMessage.focus();
        return false;
    }
    return true;
}
